import { TState } from './AppContextTypes';

export const initialState: TState = {
	inactive: false,
	requestCard: {
		enabled: false,
		state: false,
		defaultUsernameCard: '',
		nombre: '',
		apellido: '',
		numPass: '',
		userPhone: '',
		taskId: '',
		documentId: '',
	},
	requestCardJointAccount: {
		radical: [],
	},
	requestListCard: [],
	requestMovementsCard: [],
	requestLimitsCard: {
		currency: '',
		limit: null,
		balanceProvided: null,
		balanceAvailable: null,
	},
	userProfiling: {
		radicalList: [],
		radicalCli: '',
		radicalJoinAccounts: '',
		radicalCliJoinAccounts: '',
		radicalCliKidsAccounts: '',
		radicalAutonomousAccounts: '',
		radicalId: '',
		radicalCuenta: '',
		radicalInvestment: '',
		profilInvestment: '',
		jurisdiction: '',
		nombre: '',
		apellido: '',
		descriptionName: '',
		descriptionNameJoinAccounts: '',
		descriptionNameAutonomousAccounts: '',
		descriptionNameInvestment: '',
		tipges: '',
		reiden: '',
		managedAccount: '',
		juniorAccounts: [],
		miniAccounts: [],
		investmentAccounts: [],
		profilMYBInvestment: '',
		estadoAutonomousAccounts: '',
	},
	userContactInformation: {
		taxAddress: {
			line1: '',
			line2: '',
			line3: '',
			line4: '',
			line5: '',
			countryId: '',
		},
		postalAddress: {
			line1: '',
			line2: '',
			line3: '',
			line4: '',
			line5: '',
			countryId: '',
		},
		favoriteDevice: {
			id: '',
			duid: '',
			name: '',
			channel: '',
			contract_id: '',
			language: '',
			favourite: '',
			status: '',
			token: '',
			os: '',
			os_version: '',
			last_acces: '',
			token_date: '',
			create_date: '',
			delete_date: '',
			notificationPlatform: '',
			alias: ''
		},
		operationsPhone: {
			number: '',
			prefix: '',
			countryId: '',
		},
		shoppingPhone: null,
		email: '',
		favoriteChannel: '',
		addressEnabled: false,
		contactError: null,
		otpPush: '',
		phoneAssignation: {
			codiTelOpera: '',
			codiTelTarjeta: '',
		},
	},
	bizum: {
		showBizumHeader: false,
		userId: '',
		sessionId: '',
		sessionClientId: '',
		cipherKey: '',
		cipherKey64: '',
		userBizumNickName: '',
		aliasList: [{ aliasId: '', aliasType: '', aliasVerification: '' }],
		userCondVersion: '',
		iban: '',
		userPortabilityCode: '',
		userPIN: '',
		ongInfo: [],
		ongInfoIndex: 1,
		ongInfoFilter: '',
		historic: [],
		userBizumPhone: '',
		result: '',
		userStatus: '',
		OthrId_Id: undefined,
	},
	banners: [],
	dataAccount: 0,
	listAccounts: [
		{
			accountId: '',
			accountingBalanceEvaluation: 0,
			alias: '',
			availableBalanceCurrencyAccount: 0,
			availableBalanceCurrencyEvaluation: 0,
			availableCurrencyCurrencyAccount: 'EUR',
			availableCurrencyCurrencyEvaluation: '',
			balanceHeldCurrencyEvaluation: 0,
			bic: '',
			bookBalanceCurrencyAccount: 0,
			countableCurrencyAccount: '',
			countableCurrencyEvaluation: '',
			currencyPendingCurrencyEvaluation: '',
			currencyWithheldCurrencyAccount: '',
			currencyWithheldCurrencyEvaluation: '',
			iban: '',
			indicadorCargos: false,
			lastChangeDateTime: '',
			lastCommittedTransaction: '',
			liquidation: '',
			nameProduct: '',
			outstandingBalanceCurrencyAccount: 0,
			outstandingBalanceCurrencyEvaluation: 0,
			pendingCurrencyAccountCurrency: '',
			radicalPerson: '',
			referenceDate: '',
			retainedBalanceCurrencyAccount: 0,
			status: '',
			statuscli: '',
			'textetab222-1': '',
			'textetab222-2': '',
			subProduct: '',
			tipProduct: '',
			tarifa: '',
		},
	],
	listBeneficiaries: [{
		address: "",
		alias: "",
		bank: "",
		beneficiaryAccount: "AD3300031101109103510104",
		beneficiaryId: "0000001",
		city: "",
		codPostal: "",
		country: "AND",
		name: "Jordi Fernandez",
		telephone: ""
	}],
	listJointAccounts: [],
	listAutonomousAccounts: [],
	listJuniorAccounts: [],
	listTotalCurrencyMinorAccounts: [],
	listKidsAccounts: [],
	listInvestmentAccounts: [],
	account: {
		accountId: '',
		accountingBalanceEvaluation: 0,
		alias: '',
		availableBalanceCurrencyAccount: 0,
		availableBalanceCurrencyEvaluation: 0,
		availableCurrencyCurrencyAccount: 'EUR',
		availableCurrencyCurrencyEvaluation: '',
		balanceHeldCurrencyEvaluation: 0,
		bic: '',
		bookBalanceCurrencyAccount: 0,
		countableCurrencyAccount: '',
		countableCurrencyEvaluation: '',
		currencyPendingCurrencyEvaluation: '',
		currencyWithheldCurrencyAccount: '',
		currencyWithheldCurrencyEvaluation: '',
		iban: '',
		indicadorCargos: false,
		lastChangeDateTime: '',
		lastCommittedTransaction: '',
		liquidation: '',
		nameProduct: '',
		outstandingBalanceCurrencyAccount: 0,
		outstandingBalanceCurrencyEvaluation: 0,
		pendingCurrencyAccountCurrency: '',
		referenceDate: '',
		retainedBalanceCurrencyAccount: 0,
		status: '',
		statuscli: '',
		'textetab222-1': '',
		'textetab222-2': '',
		subProduct: '',
		tipProduct: '',
		tarifa: '',
	},
	autonomousAccount: {
		accountId: '',
		radicalPerson: '',
		accountingBalanceEvaluation: 0,
		alias: '',
		availableBalanceCurrencyAccount: 0,
		availableBalanceCurrencyEvaluation: 0,
		availableCurrencyCurrencyAccount: 'EUR',
		availableCurrencyCurrencyEvaluation: '',
		balanceHeldCurrencyEvaluation: 0,
		bic: '',
		bookBalanceCurrencyAccount: 0,
		countableCurrencyAccount: '',
		countableCurrencyEvaluation: '',
		currencyPendingCurrencyEvaluation: '',
		currencyWithheldCurrencyAccount: '',
		currencyWithheldCurrencyEvaluation: '',
		iban: '',
		indicadorCargos: false,
		lastChangeDateTime: '',
		lastCommittedTransaction: '',
		liquidation: '',
		nameProduct: '',
		outstandingBalanceCurrencyAccount: 0,
		outstandingBalanceCurrencyEvaluation: 0,
		pendingCurrencyAccountCurrency: '',
		referenceDate: '',
		retainedBalanceCurrencyAccount: 0,
		status: '',
		statuscli: '',
		'textetab222-1': '',
		'textetab222-2': '',
		subProduct: '',
		tipProduct: '',
		tarifa: '',
	},
	jointAccount: {
		accountId: '',
		accountingBalanceEvaluation: 0,
		alias: '',
		availableBalanceCurrencyAccount: 0,
		availableBalanceCurrencyEvaluation: 0,
		availableCurrencyCurrencyAccount: 'EUR',
		availableCurrencyCurrencyEvaluation: '',
		balanceHeldCurrencyEvaluation: 0,
		bic: '',
		bookBalanceCurrencyAccount: 0,
		countableCurrencyAccount: '',
		countableCurrencyEvaluation: '',
		currencyPendingCurrencyEvaluation: '',
		currencyWithheldCurrencyAccount: '',
		currencyWithheldCurrencyEvaluation: '',
		iban: '',
		indicadorCargos: false,
		lastChangeDateTime: '',
		lastCommittedTransaction: '',
		liquidation: '',
		nameProduct: '',
		outstandingBalanceCurrencyAccount: 0,
		outstandingBalanceCurrencyEvaluation: 0,
		pendingCurrencyAccountCurrency: '',
		referenceDate: '',
		retainedBalanceCurrencyAccount: 0,
		status: '',
		statuscli: '',
		'textetab222-1': '',
		'textetab222-2': '',
		subProduct: '',
		tipProduct: '',
		tarifa: '',
	},
	juniorAccount: {
		accountId: '',
		accountingBalanceEvaluation: 0,
		alias: '',
		availableBalanceCurrencyAccount: 0,
		availableBalanceCurrencyEvaluation: 0,
		availableCurrencyCurrencyAccount: 'EUR',
		availableCurrencyCurrencyEvaluation: '',
		balanceHeldCurrencyEvaluation: 0,
		bic: '',
		bookBalanceCurrencyAccount: 0,
		countableCurrencyAccount: '',
		countableCurrencyEvaluation: '',
		currencyPendingCurrencyEvaluation: '',
		currencyWithheldCurrencyAccount: '',
		currencyWithheldCurrencyEvaluation: '',
		iban: '',
		indicadorCargos: false,
		lastChangeDateTime: '',
		lastCommittedTransaction: '',
		liquidation: '',
		nameProduct: '',
		outstandingBalanceCurrencyAccount: 0,
		outstandingBalanceCurrencyEvaluation: 0,
		pendingCurrencyAccountCurrency: '',
		referenceDate: '',
		retainedBalanceCurrencyAccount: 0,
		status: '',
		statuscli: '',
		'textetab222-1': '',
		'textetab222-2': '',
		subProduct: '',
		tipProduct: '',
		tarifa: '',
	},
	kidsAccount: {
		accountId: '',
		accountingBalanceEvaluation: 0,
		alias: '',
		availableBalanceCurrencyAccount: 0,
		availableBalanceCurrencyEvaluation: 0,
		availableCurrencyCurrencyAccount: 'EUR',
		availableCurrencyCurrencyEvaluation: '',
		balanceHeldCurrencyEvaluation: 0,
		bic: '',
		bookBalanceCurrencyAccount: 0,
		countableCurrencyAccount: '',
		countableCurrencyEvaluation: '',
		currencyPendingCurrencyEvaluation: '',
		currencyWithheldCurrencyAccount: '',
		currencyWithheldCurrencyEvaluation: '',
		iban: '',
		indicadorCargos: false,
		lastChangeDateTime: '',
		lastCommittedTransaction: '',
		liquidation: '',
		nameProduct: '',
		outstandingBalanceCurrencyAccount: 0,
		outstandingBalanceCurrencyEvaluation: 0,
		pendingCurrencyAccountCurrency: '',
		referenceDate: '',
		retainedBalanceCurrencyAccount: 0,
		status: '',
		statuscli: '',
		'textetab222-1': '',
		'textetab222-2': '',
		subProduct: '',
		tipProduct: '',
		tarifa: '',
	},
	accountInvestment: {
		accountId: '',
		accountingBalanceEvaluation: 0,
		alias: '',
		availableBalanceCurrencyAccount: 0,
		availableBalanceCurrencyEvaluation: 0,
		availableCurrencyCurrencyAccount: 'EUR',
		availableCurrencyCurrencyEvaluation: '',
		balanceHeldCurrencyEvaluation: 0,
		bic: '',
		bookBalanceCurrencyAccount: 0,
		countableCurrencyAccount: '',
		countableCurrencyEvaluation: '',
		currencyPendingCurrencyEvaluation: '',
		currencyWithheldCurrencyAccount: '',
		currencyWithheldCurrencyEvaluation: '',
		iban: '',
		indicadorCargos: false,
		lastChangeDateTime: '',
		lastCommittedTransaction: '',
		liquidation: '',
		nameProduct: '',
		outstandingBalanceCurrencyAccount: 0,
		outstandingBalanceCurrencyEvaluation: 0,
		pendingCurrencyAccountCurrency: '',
		referenceDate: '',
		retainedBalanceCurrencyAccount: 0,
		status: '',
		statuscli: '',
		'textetab222-1': '',
		'textetab222-2': '',
		subProduct: '',
		tipProduct: '',
		tarifa: '',
	},
	pendingTasks: 0,
	wallets: [],
	indiceRiesgo: '',
	investmentSelected: {
		namelisting: '',
		longnamelisting: '',
		isincode: '',
		category: '',
		risc: '',
		codeiso: '',
		namefundmanager: '',
		mininvestment: '',
		maxinvestment: '',
		initialamount: '',
		rentabilidad: '',
		valorLiquidativo: '',
		fechaValorLiquidativo: '',
		ultimaVariacionImp: '',
		ultimaVariacionPorc: '',
		rutaDesde: '',
	},
	movementsCardIdSelected: '',
	isValidInvestmentRadical: false,
	isValidDepositRadical: false,
	investFundItem: {
		accruedint: '',
		accruedintde: '',
		assetclass: '',
		assetorder: '',
		balance: '',
		balancepurc: '',
		begindate: '',
		cappl: '',
		ccypl: '',
		contracte: '',
		costexchrate: '',
		costprice: '',
		ctr: '',
		currentprice: '',
		dataadq: '',
		dateproxcup: '',
		datoper: '',
		datultcup: '',
		denominacio: '',
		divcpt: '',
		divisapos: '',
		divisapurc: '',
		divisaval: '',
		dossier: '',
		duracionrf: '',
		exchrate: '',
		freccupon: '',
		fundfreq: '',
		gendername: '',
		genere: '',
		idcontracte: '',
		intrate: '',
		isino: '',
		lastforward: '',
		maturity: '',
		mercat: '',
		mktvalue: '',
		mktvaluepurc: '',
		modduration: '',
		nationaldesc: '',
		nationali: '',
		netcostvalpo: '',
		netcostvalre: '',
		nistrdenom: '',
		pes: '',
		pl1: '',
		pl2: '',
		plfinal: '',
		preuforward: '',
		preuspot: '',
		preustrike: '',
		quantitat: '',
		radical: '',
		rate: '',
		rating1: '',
		rating2: '',
		rating3: '',
		refpos: '',
		refvalor: '',
		resultpos: '',
		riesgo: '',
		rubrica: '',
		sector: '',
		sectordesc: '',
		subasset: '',
		tickero: '',
		tipooper: '',
		tipsub: '',
		tipus: '',
		underdenom: '',
		yellowkey: '',
		ytm: '',
	},
	dataSubWallet: {
		dataPortfolioTypeL: [],
		dataWalletProfitability: [],
		rutaDesde: '',
	},
	dataWallet: {
		canShow: false,
		dataPortfolioTypeL: [],
		dataWalletProfitability: [],
		rutaDesde: '',
	},
	orderSelected: {
		displayQuantity: 0,
		expirationDate: '',
		instruments: [],
		limitPrice: 0,
		netAmount: 0,
		cancelable: '',
		orderId: '',
		orderValue: 0,
		quantity: 0,
		side: '',
		status: '',
		transactionDate: '',
		orderType: '',
		price: 0,
		marketPrice: 0,
	},
	dataOrderDelete: {
		fileId: '',
		operationId: '',
		taskId: '',
		leftButtonOkUrl: '',
		rightButtonOkUrl: '',
		backButtonPinUrl: '',
	},
	dataDepositSelected: {
		savingsId: '',
		nameProduct: '',
		currency: '',
		typeOfInterest: 0,
		expirationDate: '',
		finalDate: '',
		initialDate: '',
		amount: 0,
		amountCurrency: 0,
		interesAmount: 0,
		interesAmountCurrency: 0,
		tipoCuenta: ''
	},
	dataBizumSubscriptionSelected: {
		concepto: '',
		estado: '',
		fechaAlta: '',
		idOperacionPadre: '',
		logo: {
			image: '',
			name: '',
		},
		monto: '',
		nombreComercio: '',
		tid: '',
	},
	dataPortfolioInvestment: undefined,
	dataPortfolioLoaded: false,
	bizumTabSelected: 0,
	userUSD: true,
	accountPositionCarousel: 0,
	movementAccountIdSelected: 0,
	disableMenuTransferAccount: false,
	insuranceSelected: {
		recibdate: '',
		vencdate: '',
		efecdate: '',
		id: '',
		status: '',
		type: '',
		details: {
			coverages: [],
			demiseCoverage: 0,
			healthcarePlan: 0,
			instalmentAmoutunt: 0,
			instalmentDate: '',
			monthlyInstalment: 0,
			monthlyNetSalari: 0,
			paymentFreq: '',
			professionalActivityType: '',
			quarterlyInstalment: 0,
			seriousDiseaseCoverage: 0,
			sickLeaveExcess: 0
		}
	},
	insuranceSimulationSelected: {
		efecdate: '',
		id: '',
		type: '',
		details: {
			monthlyInstalment: 0,
			quarterlyInstalment: 0,
			biannualInstalment: 0,
			annualInstalment: 0,
			demiseCoverage: 0,
			estadoSimu: '',
			coverages: [],
			seriousDiseaseCoverage: 0,
			healthcarePlan: 0,
			professionalActivityType: '',
			sickLeaveExcess: 0,
			monthlyNetSalari: 0
		}
	},
	simulationlist: [],
	lastLocationBeforePreviousSimulations: '',
	listCard: [],
	isListCardLoaded: false,
	listJointAccountsCard: [],
	typeNewJointAccount: '',
	errorActivateJoinAccount: undefined,
	savings: {
		savingsArray: [],
		savingsTotalCurrency: 0,
		totalAccruedInterestSavingsCurrency: 0,
		generalTotalSavingsCurrency: 0,
		resumeCode: '',
	},
	userProfilingConfig: {
		'static-config': {
			languages: {
				default: '',
			},
		},
		'menu-profiles': [
			{
				jurisdiccion: '',
				perfil: '',
				cuentas: {
					listado: false,
					movimientos: false,
					'solicitud-talonario': false,
				},
				tarjetas: {
					listado: true,
					movimientos: false,
					datos: false,
					'traspaso-ctatj': false,
					'traspaso-tjcta': false,
					bloqueo: false,
					'cambio-limite': false,
					'ver-pin': false,
					'activar-tarjeta': false,
				},
				prestamos: {
					listado: false,
					'cuadro-amortizacion': false,
				},
				patrimonio: {
					portfolio: false,
					'acceso-productos': false,
				},
				'area-personal': {
					'mis-datos': false,
					'cambio-password': false,
					correspondencia: false,
					'comunicados-luxemburgo': false,
					'doc-fiscal': false,
					informes: false,
					'extractos-fiscales': false,
					reporting: false,
					mifid: false,
					'reporting-pms': false,
					'pending-tasks': false,
				},
				transferencias: {
					traspasos: false,
					'transferencia-nacional': false,
					'transferencia-internacional': false,
					listado: false,
					'ordenes-permanentes': false,
				},
				'ahorro-inversion': {
					listado: false,
				},
				valores: {
					'acceso-pam': false,
					carteras: false,
					'ver-ficha': false,
					operar: false,
					'historico-operaciones': false,
					mercados: false,
					'historico-valores': false,
					noticias: false,
				},
				empresas: {
					'generacion-remesas': false,
					'gestion-ficheros': false,
					confirming: false,
				},
				notificaciones: {
					'firmar-contrato': false,
					'validar-datos-personales': false,
				},
				myAndbank: {
					'application-theme': 'STD',
					perfilId: '',
					permissions: {
						insurance: '',
						cards: '',
						'privacidad-modificarpwd': '',
						'investment-portfolio': '',
						'datos-personales': '',
						banners: '',
						transferencias: '',
						documentación: '',
						objetivos: '',
						'accounts-usd': '',
						'investment-funds': '',
						'cuentas-conjuntas': '',
						savings: '',
						accounts: '',
						bizum: '',
						'new-release': '',
						buzón: '',
						kids: '',
						beneficios: '',
						privacidad: '',
						modificarpwd: '',
						configuracion: '',
						'card-brazil': '',
						'transfer-only-beneficiaries': '',
						'card-pre-residente': '',
						crypto: '',
						'cuenta-autonomo': '',
					},
				},
			},
		],
	},
	expiredDocumentation: {
		message: '',
    	bloqueos: []
	},
	expiredDocumentationJoinAccounts: {
		message: '',
    	bloqueos: []
	},
	typeGPCardJointAccount: '',
	dataClientsJointAccount: {
		client1: {
			activo: false,
			country: '',
			countryBirth: '',
			dateBirth: '',
			dateNumResidence: '',
			datedocument: '',
			dateresident: '',
			direction1: '',
			direction2: '',
			direction3: '',
			document: '',
			email: '',
			id: 0,
			maritalStatus: '',
			name: '',
			nationality: '',
			numFiscal: '',
			numNRT: '',
			numresident: '',
			personType: '',
			placeBirth: '',
			population: '',
			postalcode: '',
			radicalPerson: '',
			surname: '',
		},
		client2: {
			activo: false,
			country: '',
			countryBirth: '',
			dateBirth: '',
			dateNumResidence: '',
			datedocument: '',
			dateresident: '',
			direction1: '',
			direction2: '',
			direction3: '',
			document: '',
			email: '',
			id: 0,
			maritalStatus: '',
			name: '',
			nationality: '',
			numFiscal: '',
			numNRT: '',
			numresident: '',
			personType: '',
			placeBirth: '',
			population: '',
			postalcode: '',
			radicalPerson: '',
			surname: '',
		},
	},
	accountCarouselSelected: {
		accountId: '',
		accountingBalanceEvaluation: 0,
		alias: '',
		availableBalanceCurrencyAccount: 0,
		availableBalanceCurrencyEvaluation: 0,
		availableCurrencyCurrencyAccount: 'EUR',
		availableCurrencyCurrencyEvaluation: '',
		balanceHeldCurrencyEvaluation: 0,
		bic: '',
		bookBalanceCurrencyAccount: 0,
		countableCurrencyAccount: '',
		countableCurrencyEvaluation: '',
		currencyPendingCurrencyEvaluation: '',
		currencyWithheldCurrencyAccount: '',
		currencyWithheldCurrencyEvaluation: '',
		iban: '',
		indicadorCargos: false,
		lastChangeDateTime: '',
		lastCommittedTransaction: '',
		liquidation: '',
		nameProduct: '',
		outstandingBalanceCurrencyAccount: 0,
		outstandingBalanceCurrencyEvaluation: 0,
		pendingCurrencyAccountCurrency: '',
		referenceDate: '',
		retainedBalanceCurrencyAccount: 0,
		status: '',
		statuscli: '',
		'textetab222-1': '',
		'textetab222-2': '',
		subProduct: '',
		tipProduct: '',
		tarifa: '',
	},
	isJointAccount: false,
	showModalInviteJointAccount: true,
	dataGetCaseByRadicalPerson: {
		caseIdKycJointAccount: '',
		radicalAccountJointAccount: '',
		taskIdJointAccount: undefined,
	},
	dataGetCaseByRadicalPersonKids: {
		taskIdKidsAccount: undefined,
		caseIdKycKidsAccount: '',
		radicalAccountKidsAccount: '',
		tipoAltaKidsAccount: null,
		subTipoAltaKidsAccount: null,
	},
	dataClientKidsAccount: {
		client1: {
			activo: false,
			country: '',
			countryBirth: '',
			dateBirth: '',
			dateNumResidence: '',
			datedocument: '',
			dateresident: '',
			direction1: '',
			direction2: '',
			direction3: '',
			document: '',
			email: '',
			id: 0,
			maritalStatus: '',
			name: '',
			nationality: '',
			numFiscal: '',
			numNRT: '',
			numresident: '',
			personType: '',
			placeBirth: '',
			population: '',
			postalcode: '',
			radicalPerson: '',
			surname: '',
		},
		client2: {
			activo: false,
			country: '',
			countryBirth: '',
			dateBirth: '',
			dateNumResidence: '',
			datedocument: '',
			dateresident: '',
			direction1: '',
			direction2: '',
			direction3: '',
			document: '',
			email: '',
			id: 0,
			maritalStatus: '',
			name: '',
			nationality: '',
			numFiscal: '',
			numNRT: '',
			numresident: '',
			personType: '',
			placeBirth: '',
			population: '',
			postalcode: '',
			radicalPerson: '',
			surname: '',
		},
	},
	accountKidsCarouselSelected: {
		accountId: '',
		radicalPerson: '',
		accountingBalanceEvaluation: 0,
		alias: '',
		availableBalanceCurrencyAccount: 0,
		availableBalanceCurrencyEvaluation: 0,
		availableCurrencyCurrencyAccount: 'EUR',
		availableCurrencyCurrencyEvaluation: '',
		balanceHeldCurrencyEvaluation: 0,
		bic: '',
		bookBalanceCurrencyAccount: 0,
		countableCurrencyAccount: '',
		countableCurrencyEvaluation: '',
		currencyPendingCurrencyEvaluation: '',
		currencyWithheldCurrencyAccount: '',
		currencyWithheldCurrencyEvaluation: '',
		iban: '',
		indicadorCargos: false,
		lastChangeDateTime: '',
		lastCommittedTransaction: '',
		liquidation: '',
		nameProduct: '',
		outstandingBalanceCurrencyAccount: 0,
		outstandingBalanceCurrencyEvaluation: 0,
		pendingCurrencyAccountCurrency: '',
		referenceDate: '',
		retainedBalanceCurrencyAccount: 0,
		status: '',
		statuscli: '',
		'textetab222-1': '',
		'textetab222-2': '',
		subProduct: '',
		tipProduct: '',
		tarifa: '',
	},
	subTipoAltaBloquedAccount: null,
	goalCarouselSelected: {
		acumulado: 0,
		cuenta: '',
		idObjetivo: 0,
		nombreImagen: '',
		nombreOjetivo: '',
		objetivoAhorro: 0,
	},
	listGoals: [],
	goalPositionCarousel: 0,
	listKidsCard: [],
	listAutonomousCard: [],
	accountKidsPositionCarousel: 0,
	routesFromHeaderMobile: {
		routeFromSavingGoal: '',
		routeFormCards: ''
	},
	depositItem: {
		tin: '0,00',
		type: '',
	},
	walletCreditAccount: '',
	originCard: '',
	endInsuranceResults: {
		isError: false,
		isOk: false
	},
	walletCarouselSelected: {
		data: {},
		dataTypeL: {},
		dataTypeLCartera: {},
		dataCartera: {},
		state: '',
		radical: '',
		account: {}
	},
	listWallets: [],
	walletPositionCarousel: 0,
	portfolioTypeChildrenList: [],
	userKidSelected: {
		radicalCli: '',
		radicalId: '',
		radicalCuenta: '',
		radicalInvestment: '',
		profilInvestment: '',
		jurisdiction: '',
		nombre: '',
		apellido: '',
		descriptionName: '',
		descriptionNameInvestment: '',
		tipges: '',
		reiden: '',
		managedAccount: '',
		investmentAccountsKids: [],
	},
	profilNewWallet: '',
	menuOpenGP: false,
	dataPortfolioDeposits: undefined,
	isOriginGPKids: false,
	cryptoList: [],
	selectedCrypto: null,
	contratedCryptoList: [],
	selectedContratedCrypto: null,
	cryptoListMYB: [],
	isValidCryptoRadical: false,
	isValidCjFondosRadical: false,
	isOriginPersonalInformation: false,
	isUpdateWallet: false,
	kycDataList: [],
	isKycOriginModalGP: false,
	kycGPSelected: {
		accountId: '',
		encoen: '',
		endaen: '',
		endepe: '',
		enhoen: '',
		enpes: '',
		enrad: '',
		fechaCaducidad: '',
		iban: '',
		message: ''
	},
	attachDocumentList: [],
	documentIdentityValidRad: '',
	documentFondosValidRad: '',
	kycVigenteValidRad: false,
	userLanguage: 'ca',
	isKycOriginModalCryptoOperations: false,
	isFriendsAndFamily: false,
	depositRadicalInAccount: false,
	depositRadicalInAccount5000: false,
	deviceSelected: undefined,
	isDeviceRegistration: false,
	isAutonomos: false,
	isAutonomosAccountInactive: false,
	showAutonomosInactiveModal: false,
	isAmountVisible: (() => {
		// Initialize from localStorage if available, otherwise default to true
		const savedVisibility = localStorage.getItem('balanceVisibility');
		return savedVisibility !== null ? JSON.parse(savedVisibility) : true;
	})(),
	isOriginHireWalletEnd: false,
};
